import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'
import ContractUpdatesList from 'pages/Commercial/ContractsUpdates/List'

export const ContractsUpdatesRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route
      path="/commercial/contractsUpdates"
      component={ContractUpdatesList}
      exact
    />
  </CustomSwitch>
)
